
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "regenerator-runtime/runtime";

require('./bootstrap');
window.Vue = require('vue');

import VueRouter from 'vue-router';
import Affix from 'vue-affix';
import VTooltip from 'v-tooltip';
import VueFlatPickr from 'vue-flatpickr-component';
import * as Vuetable from 'vuetable-2';
import VueAnalytics from 'vue-analytics';
import InstantSearch from 'vue-instantsearch';

Vue.use( VueRouter );
Vue.use( Affix );
Vue.use( VueFlatPickr );
Vue.use( Vuetable );
Vue.use( require('vue-shortkey'), { prevent: ['.ql-editor', 'input', 'textarea'] } );
Vue.use( VTooltip );
Vue.use( require('vue-chartist') );
Vue.use(InstantSearch);

import store from './store';
import router from './routes';

Vue.use(VueAnalytics, {
  id: 'UA-161035144-1',
  router
});

const app = new Vue({
    el: '#app',
    router: router,
    store,
    created() {
		// this.$store.dispatch('user/fetchProfile');
	},
	render: (createElement) => createElement('div', {
	    attrs: {
	        id: 'app',
	    },
	}, [
	    createElement('router-view', {
	        class: {
	            'view': true,
	        }
	    }),
	]),
});


document.body.addEventListener('keyup', ev => {
    if(ev.code === "Backquote"){
        debugger;
    }
});

